export default {
    data() {
        return {
            errors: {}
        }
    },

    methods: {
        hasError(key) {
            return this.errors.hasOwnProperty(key) && Array.isArray(this.errors[key])
        },
        getError(key) {
            return this.hasError(key) ? this.errors[key][0] : null
        },
        setErrors(errors) {
            this.errors = errors
        },
        resetErrors() {
            this.errors = {}
        }
    }
}


// WEBPACK FOOTER //
// ./client/mixins/simpleFormErrors.js